import React, { useEffect, useState } from "react";

const DTOViewCompletedTraining = () => {
  return <></>;
};
export default DTOViewCompletedTraining;
